import config from '../config';
import { removeToken, setToken } from '../token';

export const getOAuthRedirectionPath = (): string =>
  `${config.api.oauthClientSecureRedirectionPath}null?frontend-url=${window.location.href}`;

const redirectToTmsLogin = (): void => {
  window.location.href = `https://${window.location.hostname}${getOAuthRedirectionPath()}`;
};

// A stale token fails every in-flight request with 401 at once; only the first one should redirect.
// This is a time window, not a permanent flag: if the redirect is cancelled (e.g. the user clicks "Stay"
// on the unsaved-changes prompt, or returns via the back/forward cache), later 401s must redirect again.
export const LOGIN_PROMPT_WINDOW_MS = 5000;

let lastLoginPromptAt: number | undefined;

export const removeJWTAndPromptForLogin = (): void => {
  const now = Date.now();

  if (lastLoginPromptAt !== undefined && now - lastLoginPromptAt < LOGIN_PROMPT_WINDOW_MS) {
    return;
  }

  lastLoginPromptAt = now;
  removeToken();
  redirectToTmsLogin();
};

export const completeLogin = (token: string): void => {
  setToken(token);
};

export default { getOAuthRedirectionPath, removeJWTAndPromptForLogin, completeLogin };
